import React, { useEffect, useState } from "react";
import cn from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { ToolTip } from "../tooltip/tooltip";
import { Icon } from "@components/atoms/icon/icon";
import { RootState } from "@src/reducers/store";
import { updateModalsCloseDrawerModal } from "@src/reducers/your-reducer";
import styles from "./notifications-icon-button.module.scss";

interface NotificationsIconButtonPropTypes {
  content: string;
  ariaLabel: string;
  iconName?: string;
  height?: number;
  width?: number;
}

const DEFAULT_ICON_NAME = "notification_icon";
const DEFAULT_HEIGHT = 24;
const DEFAULT_WIDTH = 24;
const ICON_NAME_WITH_ORANGE_DOT = "alarm_notification";

const cssClassName = "notifications-icon-button";

export const NotificationsIconButton = ({
  content,
  ariaLabel,
  iconName = DEFAULT_ICON_NAME,
  height = DEFAULT_HEIGHT,
  width = DEFAULT_WIDTH,
}: NotificationsIconButtonPropTypes) => {
  const dispatch = useDispatch();

  const showModal = useSelector(
    (state: RootState) =>
      state.yourSlice.modals.alarmsNotificationsDrawerModal.showModal,
  );

  const [hasUnread, setHasUnread] = useState(false);

  const lastEvent = useSelector(
    (state: RootState) =>
      state.sseSlice.streams?.["service-machine-events"]?.["lastEvent"],
  );
  const lastEventAt = useSelector(
    (state: RootState) =>
      state.sseSlice.streams?.["service-machine-events"]?.["lastEventAt"],
  );

  const notificationIconName = hasUnread ? ICON_NAME_WITH_ORANGE_DOT : iconName;

  useEffect(() => {
    if (!lastEvent) return;

    if (!showModal) {
      setHasUnread(true);
    }
  }, [lastEvent, lastEventAt]);

  const toggleNotificationsDrawer = () => {
    dispatch(
      updateModalsCloseDrawerModal({
        showModal: false,
        id: "supportChatDrawerModal",
      }),
    );
    dispatch(
      updateModalsCloseDrawerModal({
        showModal: !showModal,
        id: "alarmsNotificationsDrawerModal",
      }),
    );
    if (!showModal) {
      setHasUnread(false);
    }
  };

  return (
    <ToolTip position={"bottom"} content={content}>
      <button
        type="button"
        className={cn(
          styles[cssClassName],
          styles[`${cssClassName}__hover`],
          styles[`${cssClassName}__center-content`],
          showModal && styles[`${cssClassName}__active`],
        )}
        onClick={toggleNotificationsDrawer}
        aria-label={ariaLabel}
      >
        <Icon name={notificationIconName} width={width} height={height} />
      </button>
    </ToolTip>
  );
};
